"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NO_FRAME_IMAGE = void 0;
const NO_FRAME_IMAGE = exports.NO_FRAME_IMAGE = 'no-frame-image';
